import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { getUserProfile, getLanguage, getSecurityQuestions } from '../../store/rootReducer';
import HrbTranslate from "../language/HrbTranslate";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import './UserProfile.scss'
import * as languageActions from '../language/ducks/actions';
import PersonalInformation from './personal-info/PersonalInformation';
import PasswordInfo from './password/PasswordInfo';
import SecondaryAuthInfo from './secondary-auth-method/SecondaryAuthMethod';
import Api from "../../services/api/Api";
import { ApiPaths } from "../../services/api/ApiPaths";
import { RouteConstants } from "../route/services/RouteConstants";
import UrlParamsUtil from '../../services/util/UrlParamsUtil';
import auth from '../../services/auth/AuthProvider'
import DialogBox from './common/DialogBox';
import { HeapEvents, trackEvent } from '../../services/util/AnalyticsUtil';

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            profile: null,
            errorCode: null,
            isExternal: false,
            showResetDialog: false,
            dialogTitle: '',
            dialogText: '',
            dialogCancelText: '',
            dialogConfirmText: '',
            dialogConfirmMethod: null,
            secondaryAuthMethods: [],
            returnToSource: null,
        };
    }

    componentWillMount() {
        var params = UrlParamsUtil.getQueryParamsFromUrl(this.props);
        trackEvent(HeapEvents.ACCOUNT_VIEWED);
        if (params.source && params.source === 'ext') {
            this.setState({ isExternal: true });
        }
        if (params.lang && params.lang.toUpperCase() !== this.props.lang) {
            this.props.setLanguage(params.lang.toUpperCase());
        }
        if (!this.state.isLoaded) {
            this.loadProfile();
        }
                
        this.setState({returnToSource: sessionStorage.getItem('myblock_source_app')});
    }

    loadProfile = () => {
        Api.get(ApiPaths.ACCOUNT_PROFILE).then(
            (response) => {
                if (response.status !== 200) {
                    this.setState({ profile: null, errorCode: response.status, isLoaded: true })
                } else {
                    this.setState({ profile: response.data, errorCode: null, isLoaded: true });
                }
            },
            (error) => {
                this.setState({
                    isLoaded: true,
                    errorCode: 500
                });
            }
        );
        Api.get(ApiPaths.GET_SECONDARY_AUTHENTICATION).then((authResponse) => {
            if (authResponse.status === 200) {
                this.setState({ secondaryAuthMethods: authResponse.data });
            }
        });
    }

    profileEdited = () => {
        this.props.history.replace(RouteConstants.PROFILE);
        this.setState({ isLoaded: false })
        this.loadProfile();
        // trigger a silent token refresh as well if we've change things
        auth.silentAuthentication(() => {
            return {
                language: this.props.lang || 'en'
            }
        });
    }

    backToDashboard = () => {
        if(this.state.returnToSource === null || this.state.returnToSource === "") {
            this.props.history.goBack();
        } else {
            auth.redirect(this.state.returnToSource, 'dashboard');
        }
    }

    getBackText = () => {
        if(this.state.returnToSource === null || this.state.returnToSource === "") {
            return null;
        }
        if(this.state.returnToSource === "RTE") {
            return 'common.back_to_rte';
        }
        if(this.state.returnToSource.startsWith("DIY")) {
            return 'common.back_to_diy';
        }
        return null;
    }

    editPersonalInfo = () => {
        this.props.history.push('/profile/edit');
    }

    editSecurityInfo = () => {
        this.props.history.push('/profile/security/edit')
    }

    //old change password funtion - to be removed once auth0 is stable
    editPasswordInfo = () => {
        this.props.history.push('/profile/password/edit')
    }

    changePassword = () => {
        this.setState({
            showResetDialog: true,
            dialogTitle: 'profile.password_info.dialog_title',
            dialogText: 'profile.password_info.dialog_text',
            dialogCancelText: 'profile.password_info.dialog_cancel',
            dialogConfirmText: 'profile.password_info.dialog_confirm',
            dialogConfirmMethod: this.handleConfirmDialog_ResetPassword
        });
    }

    handleConfirmDialog_ResetPassword = () => {
        this.setState({ showResetDialog: false });
        auth.logout();
        auth.login();
    }

    resetSecondaryAuthMethod = (authenticationMethod) => {
        this.setState({showResetDialog: true,
            dialogTitle: authenticationMethod === 'phone' ? 'profile.secondary_auth_info.dialog_title_sms' : 'profile.secondary_auth_info.dialog_title_authenticator_app',
            dialogText: 'profile.secondary_auth_info.dialog_text',
            dialogCancelText: 'profile.secondary_auth_info.dialog_cancel',
            dialogConfirmText: 'profile.secondary_auth_info.dialog_confirm',
            dialogConfirmMethod: this.handleConfirmDialog_ResetAuth
        });
    }

    handleCloseDialog = () => {
        this.setState({ showResetDialog: false });
    }

    handleConfirmDialog_ResetAuth = () => {
        this.setState({ showResetDialog: false });
        Api.delete(ApiPaths.RESET_SECONDARY_AUTHENTICATION).then((response) => {
            if (response.status === 200 && response.data === true) {
                this.setState({ secondaryAuthMethods: [] });
            }
        });
    }

    render() {
        return this.state.isLoaded ? (
            <div className="hrb-profile">
                <div className="hrb-profile-content">
                    {!this.state.isExternal &&
                        <Breadcrumb text={this.getBackText()} onClick={this.backToDashboard} />
                    }
                    {this.state.isExternal && 
                        <div className="hrb-profile-external-warning">
                            <HrbTranslate text='profile.external_link' />
                        </div>
                    }
                    <div className="hrb-profile-heading">
                        <HrbTranslate text="profile.title" />
                    </div>
                    {this.state.profile &&
                        <Fragment>
                            <PersonalInformation profile={this.state.profile} onEdit={this.editPersonalInfo}
                                lang={this.props.lang} profileUpdated={this.profileEdited} />
                            <div className="hrb-profile-card-spacer" />
                            <PasswordInfo profile={this.state.profile} onEdit={this.changePassword}
                                lang={this.props.lang} profileUpdated={this.profileEdited} />
                            <Fragment>
                                <div className="hrb-profile-card-spacer" />
                                <SecondaryAuthInfo onReset={this.resetSecondaryAuthMethod} secondaryAuthenticationFactors={this.state.secondaryAuthMethods} />
                            </Fragment>
                            <DialogBox
                                showResetDialog={this.state.showResetDialog}
                                handleCloseDialog={this.handleCloseDialog}
                                handleConfirmDialog={this.state.dialogConfirmMethod}
                                dialogTitle={this.state.dialogTitle}
                                dialogText={this.state.dialogText}
                                dialogCancelText={this.state.dialogCancelText}
                                dialogConfirmText={this.state.dialogConfirmText}
                            />
                        </Fragment>
                    }
                    <div className="hrb-profile-card-spacer" />
                </div>
            </div>
        ) : (
            <div className="hrb-profile">
                <LoadingSpinner />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
  return {
      userprofile: getUserProfile(state),
      lang: getLanguage(state),
      securityQuestions: getSecurityQuestions(state)
  }
};

const mapDispatchToProps = {
    ...languageActions
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserProfile));
